import $api from 'http';
import axios from 'axios';
import env from '../../package.json'


class FileUploadService {
    // Универсальный метод загрузки файла
    static async uploadFile(file, fileType, eventId = 'default', description = '') {
        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('fileType', fileType);
            formData.append('description', description);

            const response = await $api.post(`/api/file-upload/upload/${eventId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            return response.data;
        } catch (error) {
            console.error('Ошибка загрузки файла:', error);
            throw error;
        }
    }

    // Загрузить логотип
    static async uploadLogo(file, eventId = 'default') {
        return this.uploadFile(file, 'logo', eventId, 'Логотип мероприятия');
    }

    // Загрузить аватар
    static async uploadAvatar(file, eventId = 'default') {
        return this.uploadFile(file, 'avatar', eventId, 'Аватар пользователя');
    }

    // Загрузить изображение для новости
    static async uploadNewsImage(file, eventId = 'default') {
        return this.uploadFile(file, 'news_image', eventId, 'Изображение для новости');
    }

    // Загрузить баннер
    static async uploadBanner(file, eventId = 'default') {
        return this.uploadFile(file, 'banner', eventId, 'Баннер мероприятия');
    }

    // Получить файлы по типу
    static async getFilesByType(fileType, eventId = 'default') {
        try {
            const response = await $api.get(`/api/file-upload/files/type/${fileType}/${eventId}`);
            return response.data;
        } catch (error) {
            console.error('Ошибка получения файлов:', error);
            throw error;
        }
    }

    // Получить логотип (публичный API - без авторизации)
    static async getLogo(eventId = 'default') {
        try {
            const url = `${env.nodeHost}/api/file-upload/public/logo/${eventId}`;
            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            console.error('Ошибка получения логотипа:', error);
            throw error;
        }
    }

    // Получить баннер (публичный API - без авторизации)
    static async getBanner(eventId = 'default') {
        try {
            const response = await axios.get(`${env.nodeHost}/api/file-upload/public/banner/${eventId}`);
            return response.data;
        } catch (error) {
            console.error('Ошибка получения баннера:', error);
            throw error;
        }
    }

    // Получить изображение новости (публичный API - без авторизации)
    static async getNewsImage(eventId = 'default') {
        try {
            const response = await axios.get(`${env.nodeHost}/api/file-upload/public/news-image/${eventId}`);
            return response.data;
        } catch (error) {
            console.error('Ошибка получения изображения новости:', error);
            throw error;
        }
    }

    // Получить информацию о файле по ID
    static async getFileById(fileId) {
        try {
            const response = await $api.get(`/api/file-upload/file/${fileId}`);
            return response.data;
        } catch (error) {
            console.error('Ошибка получения файла:', error);
            throw error;
        }
    }

    // Удалить файл
    static async deleteFile(fileId, eventId = 'default') {
        try {
            const response = await $api.delete(`/api/file-upload/file/${fileId}/${eventId}`);
            return response.data;
        } catch (error) {
            console.error('Ошибка удаления файла:', error);
            throw error;
        }
    }

    // Обновить описание файла
    static async updateFileDescription(fileId, description) {
        try {
            const response = await $api.put(`/api/file-upload/file/${fileId}/description`, {
                description: description
            });
            return response.data;
        } catch (error) {
            console.error('Ошибка обновления описания:', error);
            throw error;
        }
    }

    // Получить все файлы для события
    static async getAllFiles(eventId = 'default') {
        try {
            const response = await $api.get(`/api/file-upload/files/${eventId}`);
            return response.data;
        } catch (error) {
            console.error('Ошибка получения всех файлов:', error);
            throw error;
        }
    }
}

export default FileUploadService;
